import { Pipe, PipeTransform } from '@angular/core';
import { getDynamicRouteLink, getDynamicRouterLink } from '../utilities/route.helpers';

@Pipe({
    name: 'routeParams'
})
export class RouteParamsPipe implements PipeTransform {
    public transform(value: string | string[], params: { [key: string]: any }): string | string[] {
        if (typeof value === 'string') {
            return getDynamicRouteLink(value, params);
        } else if (Array.isArray(value)) {
            return getDynamicRouterLink(value, params);
        }

        return value;
    }
}
